export const API_CONFIG = {
  SERVER_URL: "https://api.scfg.io",
  ASR_SERVICE: "yating",
};
